export var ACTION;
(function (ACTION) {
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["PROCEED"] = "PROCEED";
    ACTION["VERIFY_NEW_NUMBER"] = "VERIFY_NEW_NUMBER";
    ACTION["VERIFY_OTP"] = "VERIFY_OTP";
    ACTION["RESEND_OTP"] = "RESEND_OTP";
    ACTION["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTION["CLOSE_OTP_MODAL"] = "CLOSE_OTP_MODAL";
})(ACTION || (ACTION = {}));
